import React from 'react';

import { TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { FormControl } from '@material-ui/core';

export default function DiskHealthRule({ disabled, rule, rules, handleChangeRule, handleRemoveRule }) {
  const { t } = useTranslation();

  const fullOptions = ['1', '3', '4', '5', '7', '9', '10', '11', '12',
    '100', '168', '169', '174', '175', '176', '177', '179', '180', '181', '182', '183', '184', '187', '188',
    '192', '193', '194', '196', '197', '198', '199', '200', '241', '242'];

  let options = fullOptions.filter(o => {
    if (!rules.find((element) => {
      if (element.attributeId == o && element.attributeId != rule.attributeId)
        return true;
    }
    )) {
      return true;
    }
  });
  options = options.sort((a, b) => parseInt(a) > parseInt(b) ? -1 : 1);

  if (rule.attributeId == "") {
    handleChangeRule(rule, 'attributeId', options[0]);
  }

  return (
    <div className="flexRow" style={{ paddingTop: '5px' }}>

      <select
        style={{ textAlign: 'center', width: '25%' }}
        className="singleSelect"
        name={'smartAttributeId' + rule.seq}
        value={rule.attributeId}
        onChange={e => handleChangeRule(rule, 'attributeId', e.target.value)}
        disabled={disabled}
      >
        {options.map(o => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>

      <TextField
        style={{ paddingLeft: '20px', paddingRight: '20px', textAlign: 'center', width: '35%' }}

        InputProps={{
          inputProps: {
            style: { textAlign: "center" },
          }
        }}
        variant='standard'
        disabled={disabled}
        value={rule.weight}
        title={rule.weight}
        onChange={e => handleChangeRule(rule, 'weight', e.target.value)}
        placeholder={''}
      />

      <TextField
        style={{ paddingLeft: '20px', paddingRight: '20px', textAlign: 'center', width: '35%' }}

        InputProps={{
          inputProps: {
            style: { textAlign: "center" },
          }
        }}
        variant='standard'
        disabled={disabled}
        value={rule.limit}
        title={rule.limit}
        onChange={e => handleChangeRule(rule, 'limit', e.target.value)}
        placeholder={''}
      />

      <div className="actions" style={{ textAlign: 'center', width: '5%', opacity: disabled ? '0.4' : '1'}}>
        <span
          disabled={disabled}
          className="material-icons remove"
          title={t('reporting.columns.disk_health_percentage_rules.remove')}
          onClick={() => !disabled && handleRemoveRule(rule)}
        >
          remove_circle_outline
        </span>
      </div>
    </div >
  );
}
